// @flow
import gql from 'graphql-tag';

type TravelerSearch = {
    namespace: 'traveler/search',
    category: 'messages'
};

type TravelerListing = {
    namespace: 'traveler/listing',
    category: 'messages'
};

type StabFeedback = {
    namespace: 'ui-development/shared',
    category: 'stabFeedback'
};

type GlobalTemplatesTraveler = {
    namespace: 'global-templates/traveler',
    category: 'common'
};

export type Bundle =
    | TravelerSearch
    | TravelerListing
    | StabFeedback
    | GlobalTemplatesTraveler;

const translationsQuery = gql`
    query LinguaQuery($locale: String, $bundle: Bundle!) {
        translations(locale: $locale, bundle: $bundle) {
            locale
            messages
        }
    }
`;

export default translationsQuery;
